import { isImmutableRecord } from 'app/common/utils/immutable-type-util';
import { type ChangeEvent, type ChangeEventHandler, useCallback } from 'react';
import type { WidgetProps } from '../../../types.js';
import { getWidgetId, useWidgetTitle } from '../../../util/widget.js';

function toBoolean(value: unknown) {
  if (value === 'true' || value) {
    return true;
  }

  return false;
}

export type BooleanWidgetHookProps = {
  label: string;
  checked: boolean;
  handleChange: ChangeEventHandler<HTMLInputElement>;
  description?: string;
  id: string;
} & WidgetProps;

export const useBooleanWidget = (props: WidgetProps) => {
  const { schema, value, onChange, onBlur } = props;

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      onChange(event.target.checked);
      onBlur();
    },
    [onBlur, onChange]
  );

  const label = useWidgetTitle(props);
  const id = getWidgetId(props);

  return {
    ...props,
    label,
    checked: toBoolean(isImmutableRecord(value) ? value.toJS() : value),
    handleChange,
    description: schema.get('description'),
    id
  };
};
